import React from 'react';
import '../App.css';
import Header from './Header';
import Footer from './Footer';
import TableCheckout from './TableCheckout';
import { PDFDownloadLink } from "@react-pdf/renderer";
import GenerarPdf from '../services/GenerarPdf';
import ReactWhatsapp from 'react-whatsapp';




function PagarAhora(){


    const orden = JSON.parse(localStorage.getItem('Orden'));
    const storeProductos = JSON.parse(localStorage.getItem('Registrados'));

    let total=0;

    const sumall = storeProductos.map(item => item.Price);
    sumall.forEach(function(a){total+=a;});

    const numOrden = orden.ordenId;
    
    let mensaje = `Suba aqui el archivo pdf llamado ${numOrden}, busquelo en sus descargas recientes!`

    const loading=()=>{
        console.log('estoy funcionando')
        window.open(
            `https://api.whatsapp.com/send/?phone=18296735811&text=${mensaje}&type=phone_number&app_absent=0`,
            '_blank'
        );
    }
    const namePdf =`${numOrden}.pdf`;

    return(
       <>
            <Header/>

            <div className='container-form-direction'>

                <div className="terminar-orden">

                    <h1 className='orden'>Orden {numOrden}</h1>

                    <section>
                        <h1>Orden completada:</h1>
                        <article>
                            <p>Transferencia bancaria</p>
                            <p>Total:	RD$ {total+orden.pago}</p>
                        </article>
                    </section>

                    <section className='completar-orden'>

                        <h2>Para completar su pedido puede hacerlo por cualquiera de estas vias:</h2>
                        <p></p>

                        <h3><i class="fa fa-caret-right" style={{marginRight:'5px'}}></i>Transferencia o deposito:</h3>

                        <h3>BANRESERVAS</h3>
                        <h3>BANCO POPULAR</h3>

                        <h3></h3>

                        <h3>PAYPAL - <span style={{fontSize:'16px'}}>diazasmin07@gmail.com</span></h3>

                        <h3></h3>
                        <h3></h3>

                        <h3>Use el nombre del pedido como referencia.</h3>

                    </section>
                    <section className='ir-wat'>
                        <h3>Numero de orden: {numOrden}</h3>
                        <PDFDownloadLink
                            document={<GenerarPdf factura={numOrden} total={total} envio={orden.pago} envioName={orden.typeEntrega} carrito={storeProductos}/>}
                            fileName={namePdf}
                        >
                            <button class="beach-button" onClick={()=>loading()}>
                                <img src={require('../assets/images/whatsapp.png')} alt="" />
                                <span>Completar</span>
                            </button>
                        </PDFDownloadLink> 
                    </section>

                </div>

                <TableCheckout Entrega={orden.pago}/>

            </div>

            <Footer/>
       </>
    )
}

export default PagarAhora;
